"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewHeaderMiddle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lib_1 = require("../../lib");
/**
 * ViewHeaderMiddle component
 *
 * @visibleName ViewHeaderMiddle
 */
const ViewHeaderMiddleComponent = ({ children, className }) => {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)(className, 'view-header__middle') }, { children: children }), void 0));
};
exports.ViewHeaderMiddle = ViewHeaderMiddleComponent;
//# sourceMappingURL=ViewHeaderMiddle.js.map